import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { withStyles } from '@mui/styles';

const CustomLinearProgress = withStyles({
  bar2Buffer: {
    backgroundColor: '#CCD5DC !important',
  },
})(LinearProgress);

const UiLinearProgress = (props) => {
  return <CustomLinearProgress variant='buffer' {...props} />;
};

export default UiLinearProgress;
